import React, {Component} from 'react';
// import PropTypes from 'prop-types';
import styled from "styled-components";

import Colors from '../resource/ResourceColors.jsx';

import ModuleProcessors from '../module/ModuleProcessors.jsx';
import ModuleToneWalker from '../module/ModuleToneWalker.jsx';

const PANEL_HEIGHT = "10.5rem";
const CONTAINER_HEIGHT = "10.5rem";
const MODULE_HEIGHT = "8.5rem";
const CONTENT_HEIGHT = "6rem";
const BAR_WIDTH = "2.0rem";
const MARGIN = "0.5rem";
const MODULE_MARGIN = "0.25rem";

const ModuleWrapper = styled.div`
    margin: 0;
`;

const Background = styled.div`
    font-family: Arial;
    user-select: none;
    width: 100%;
    height: ${PANEL_HEIGHT};
    background: ${Colors.right_diagonal_gradient(50, 30)};
`;

const GradientBorder = styled.div`
    width: 100%;
    height: 0.20rem;
    background: ${Colors.right_diagonal_gradient_grey(80, 20)};    
`;

const ExpandedModule = styled.div`
    display: inline-grid;
    padding: ${MODULE_MARGIN};
    height: ${MODULE_HEIGHT};
    margin: ${MARGIN};
    border-radius: ${MODULE_MARGIN};
    border: 0.15rem solid ${Colors.grey(40)};
    filter: ${Colors.medium_shadow(80)};
    background: ${Colors.right_diagonal_gradient_grey(85, 50)};
`;

const RightBar = styled.div`
    position: absolute;
    right: 0;
    width: ${BAR_WIDTH};
    height: ${CONTAINER_HEIGHT};
`;

const LeftBar = styled.div`
    position: absolute;
    left: 0;
    width: ${BAR_WIDTH};
    height: ${CONTAINER_HEIGHT};
`;

const CenterBar = styled.div`
    position: absolute;
    right: ${BAR_WIDTH};
    left: ${BAR_WIDTH};
    height: ${CONTAINER_HEIGHT};
`;

const ModuleTitleBar = styled.div`
    background: ${Colors.right_diagonal_gradient(50, 20, Colors.secondary_hue())};
    width: 100%;
    height: 1.25rem;
    border-radius: 0.25rem;
    letter-spacing: 0.075rem;
`;

const ModuleTitle = styled.div`
    font-size: 0.75rem;
    letter-spacing: 0.35rem;
    color: ${Colors.secondary(85)};
    text-transform: uppercase;
    text-shadow: ${Colors.medium_text_shadow(70)};
    padding: 0.2rem 0.65rem;
`;

const ModuleContent = styled.div`
    height: ${CONTENT_HEIGHT};
    border-radius: 0.25rem;
    margin-top: 0.25rem;
    padding: 0.5rem;
    color: ${Colors.grey(95)};
    font-size: 0.75rem;
    box-shadow: inset ${Colors.wide_raw_shadow(35)};    
    background: ${Colors.right_diagonal_gradient_grey(75, 25)};
`;

const MODULES = [
    //{type: "processors", name: "Processors"},
    // {type: "tone-walker", name: "Tone Walker"},
];

export class AppModules extends Component {

    componentDidMount() {
    }

    render_module(module, rendering, key) {
        return <ExpandedModule key={'key-' + key}>
            <ModuleTitleBar>
                <ModuleTitle>{module.name}</ModuleTitle>
            </ModuleTitleBar>
            <ModuleContent>
                {rendering}
            </ModuleContent>
        </ExpandedModule>
    }

    render() {

        const modules = MODULES.map((module, key) => {
            switch (module.type) {
                case 'processors':
                    return this.render_module(module, <ModuleProcessors/>, key);
                case 'tone-walker':
                    return this.render_module(module, <ModuleToneWalker/>, key);
                default:
                    return this.render_module(module, <div>{module.name + ' not found'}</div>, key);
            }
        });
        const right_bar = <RightBar/>;
        const left_bar = <LeftBar/>;

        return <ModuleWrapper>
            <Background>
                {left_bar}
                <CenterBar>
                    {modules}
                </CenterBar>
                {right_bar}
            </Background>
            <GradientBorder/>
        </ModuleWrapper>;
    }
}

export default AppModules;
